import en from './en/EnLocale';
import ru from './ru/RuLocale';

export default {
    ru,
    en
}
